<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务中心设置管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <div class="edit_dev">
        <el-transfer
          v-model="value"
          :data="data"
          :titles="['二级科目列表', '已选二级科目']">
        </el-transfer>
      </div>

      <div class="margin t15">
        <el-button @click="$router.back()">返回</el-button>
        <el-button type="primary" @click="onSubmit">保存</el-button>
      </div>
    </layout-panel>
  </div>
</template>

<script>
// import { formRules } from '../finance-config.rules.js'
export default {
  data () {
    return {
      id: null,
      data: [],
      value: [],
    }
  },

  async created () {
    await request.common('getFinCenterConfigs').then(({data}) => {
      this.generateData(data.second_subject_source)
    })
    this.id = this.$route.params.id

    this.fetchDetail(this.id)
  },
  methods: {
    fetchDetail (id) {
      request.common('getSubjectRelationship', {id}).then(({data}) => {
        this.value = data.second_subject_ids
      })
    },
    generateData (source) {
      _.forIn(source, (value, key) => {
        !value.is_disabled && this.data.push({
          key: value.id,
          label: value.name,
        })
      })
    },
    onSubmit () {
      request.common('editSubjectRelationship', {id: this.id, second_subject_ids: this.value}).then(({data}) => {
        this.$confirm('保存成功, 是否返回列表？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/finance-config/subject-relationships-management'})
        }, () => {
          this.fetchDetail(this.id)
        })
      })
    },
  }
}
</script>

<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.edit_dev >>> .el-checkbox+.el-checkbox {
  margin-left: 0 !important;
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/finance-config/pages/PaymentSubjectRelationshipsManagementForm.vue